<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">粉丝管理</span>
      </div>
    </div>
    <div>
      <p class="title">粉丝分布图</p>
      <div class="box">
        <div class="boxs">
          <p class="bsTitle">学历分布图</p>
          <div class="bsBox"
               ref="box1"></div>
        </div>
        <div class="boxs">
          <p class="bsTitle">职称分布图</p>
          <div class="bsBox"
               ref="box2"></div>
        </div>
        <div class="boxs">
          <p class="bsTitle">科室分布图</p>
          <div class="bsBox"
               ref="box3"></div>
        </div>
        <div class="boxs">
          <p class="bsTitle">内容标签分布图</p>
          <div class="bsBox"
               ref="box4"></div>
        </div>
      </div>
      <p class="title">粉丝数据（<span>{{pageCount}}</span>人次）</p>
      <div class="listbox">
        <table>
          <thead>
            <tr>
              <th>序号</th>
              <th>姓名</th>
              <th>学历</th>
              <th>职称</th>
              <th>单位</th>
              <th>所在科室</th>
              <th style="width:350px">关注学习内容</th>
              <th style="width:90px">关注时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in storeList"
                :key="index">
              <td>{{item.userId}}</td>
              <td>{{item.userName}}</td>
              <td></td>
              <td>{{item.position}}</td>
              <td>{{item.unit}}</td>
              <td>{{item.admoffId}}</td>
              <td class="biaoqian">
                <p @click="tobiaoqian(item)">{{getLable(item.courselabel,1)}}</p>
              </td>
              <td>{{item.payDate}}</td>
            </tr>
            <tr v-show="storeList.length<1">
              <td colspan="8">暂无粉丝数据</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  @page-change="pageChange"></pagination>
    </div>
    <el-dialog title="学习内容"
               top="350px"
               :visible.sync="IsBiaoqian"
               width="500px">
      <span>{{biaoqianInfo}}</span>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  data () {
    return {
      storeList: [],
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
      myChart: '',
      IsBiaoqian: false,
      biaoqianInfo: ''
    };
  },
  created () {
    this.getStoreList()
  },
  mounted () {
    this.getMyChart()
  },
  methods: {
    getStoreList () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertFansPageList', {
        ExpertId: Number(localStorage.getItem('storeId')),
        // ExpertId: 40,
        Page: this.pageIndex,
        limit: this.pageSize
      }).then(res => {
        if (res.code == 200) {
          this.storeList = res.data
          this.pageCount = res.totalcount
        }
      });
    },
    pageChange (page) {
      if (page == this.pageIndex) return;
      this.pageIndex = page;
      this.getStoreList()
    },
    getMyChart () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertFansStatis', {
        ExpertId: Number(localStorage.getItem('storeId')),
        // ExpertId: 40,
      }).then(res => {
        if (res.code == 200) {
          this.myChart = res.data
          // 基于准备好的dom，初始化echarts实例
          var myChart1 = echarts.init(this.$refs.box1);
          var myChart2 = echarts.init(this.$refs.box2);
          var myChart3 = echarts.init(this.$refs.box3);
          var myChart4 = echarts.init(this.$refs.box4);
          // 绘制图表
          myChart1.setOption({
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '120',
              left: 'center',
              itemWidth: 8,
              itemHeight: 8,
              padding: 1,
              itemGap: 7,
              textStyle: {
                fontWeight: 400,
                fontFamily: 'Microsoft YaHei',
                fontSize: 12
              }
            },
            series: [
              {
                top: '-15',
                height: '143',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 1,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '10',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.myChart.edlist
              }
            ]
          });
          myChart2.setOption({
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '120',
              left: 'center',
              itemWidth: 8,
              itemHeight: 8,
              padding: 1,
              itemGap: 7,
              textStyle: {
                fontWeight: 400,
                fontFamily: 'Microsoft YaHei',
                fontSize: 12
              }
            },
            series: [
              {
                top: '-15',
                height: '143',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 1,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '10',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.myChart.prolist
              }
            ]
          });
          myChart3.setOption({
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '120',
              left: 'center',
              itemWidth: 8,
              itemHeight: 8,
              padding: 1,
              itemGap: 7,
              textStyle: {
                fontWeight: 400,
                fontFamily: 'Microsoft YaHei',
                fontSize: 12
              }
            },
            series: [
              {
                top: '-15',
                height: '143',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 1,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '10',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.myChart.admlist
              }
            ]
          });
          myChart4.setOption({
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '120',
              left: 'center',
              itemWidth: 8,
              itemHeight: 8,
              padding: 1,
              itemGap: 7,
              textStyle: {
                fontWeight: 400,
                fontFamily: 'Microsoft YaHei',
                fontSize: 12,
                lineHeight: 5
              }
            },
            series: [
              {
                // name: '未知',
                top: '-15',
                height: '143',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 1,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '10',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.myChart.lablist
              }
            ]
          });
        }
      });
    },
    getLable (s, t) {
      s = s.replace(/,/g, "、");
      if (s.substr(0, 1) == '、') s = s.substr(1);
      else s = s
      if (t == 1) return s
      else return s.split('、')
    },
    tobiaoqian (item) {
      this.biaoqianInfo = this.getLable(item.courselabel, 1)
      this.IsBiaoqian = true
    }
  }
}
</script>

<style scoped>
.title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 18px;
    padding-left: 14px;
    border-left: 2px solid #0b8586;
    margin-top: 30px;
    margin-bottom: 20px;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.listbox .biaoqian {
    display: flex;
    align-items: center;
    justify-content: center;
}
.listbox .biaoqian p {
    width: 330px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    cursor: pointer;
    /* display: flex;
    justify-content: center;
    align-items: center; */
}
.box {
    display: flex;
    justify-content: space-between;
}
.boxs {
    width: 143px;
    height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.boxs .bsTitle {
    height: 40px;
    line-height: 40px;
}
.boxs .bsBox {
    width: 143px;
    height: 193px;
}
</style>